module.exports = __webpack_public_path__ + "44fffbcad657af3f833c9aaf5e3f9dc2.pdf";